import { render, staticRenderFns } from "./modal-add-edit-pet-weight.vue?vue&type=template&id=221be4e4&scoped=true&lang=pug"
import script from "./modal-add-edit-pet-weight.js?vue&type=script&lang=js&external"
export * from "./modal-add-edit-pet-weight.js?vue&type=script&lang=js&external"
import style0 from "./modal-add-edit-pet-weight.vue?vue&type=style&index=0&id=221be4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221be4e4",
  null
  
)

export default component.exports